import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const SupportSection = styled.div`
  ${'' /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .options {
    text-align: center;
    li {
      &:before {
        content: '●';
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        margin: 0 7px;
      }
      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }
  @media (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
    flex-direction: row;
    justify-content: space-between;
    .options {
      text-align: left;
    }
  } */}
`;

export default SupportSection;



// WEBPACK FOOTER //
// ./src/styled-components/SupportSection.js